<template>
  <div class="text-left">
    <!-- Navigation -->
    <div class="app-admin-wrap layout-sidebar-large clearfix">
      <!-- Top Navigation -->
      <top-nav-component
        v-show="($route.name != 'login' && $route.name != 'home' && $route.name != 'auth_otp')"
      ></top-nav-component>

      <!-- Side Navigation -->
      <side-nav-component
        v-show="$route.name != 'login' && $route.name != 'home' && $route.name != 'auth_otp'"
      ></side-nav-component>

      <!-- Content -->
      <div
        class="sidenav-open d-flex flex-column"
        v-bind:class="{
          'main-content-wrap': $route.name != 'login' && $route.name != 'home' && $route.name != 'auth_otp',
          'main-content-wrap1': !(
            $route.name != 'login' && $route.name != 'home' && $route.name != 'auth_otp'
          )
        }"
      >
        <!-- Modal -->
        <div
          class="modal fade"
          id="myModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <span v-text="keystrokes"></span>
              </div>
            </div>
          </div>
        </div>
        <router-view />
        <complete-modal v-if="$route.name === 'change-forms'"></complete-modal>
      </div>
    </div>
    <footer-component v-show="$route.name != 'login' && $route.name != 'home' && $route.name != 'auth_otp'"></footer-component>
  </div>
</template>

<script>

// @ is an alias to /src
import TopNavComponent from "@/components/topnavbar.vue";
import SideNavComponent from "@/components/sidenavbar.vue";
import CompleteModal from "@/views/contents/changeform/CompleteModal.vue";
import FooterComponent from "@/components/footer.vue";
import axios from "axios";

export default {
  name: "home",
  components: {
    TopNavComponent,
    SideNavComponent,
    CompleteModal,
    FooterComponent
  },
  data() {
    return {
      buffer: [],
      keystrokes: ""
    };
  },
  methods: {
    logout() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/auth/logout", {}, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.$router.push("/login");

            localStorage.clear();

            swal({
              text: "Logout successful!",
              icon: "success",
              button: "OK"
            });
          });
      }
    }
  },
  mounted() {}
};
</script>
